import React from "react"

import ItemPrice from "../../../ui-components/ItemPrice"

import style from "./ServiceItem.module.scss"

export default function ServiceItem(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    service,
    service_key,
    onIncreaseQuantity,
    onDecreaseQuantity,
    editable = true,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleDecreaseButtonClicked(event) {
    event.preventDefault()
    onDecreaseQuantity(service_key)
  }

  function handleIncreaseButtonClicked(event) {
    event.preventDefault()
    onIncreaseQuantity(service_key, service)
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  let discount = service.total_discount_amount || 0
  let price_cents = service.total_price_cents - discount
  let original_price_cents = undefined
  if (service.total_original_price_cents) {
    original_price_cents = service.total_original_price_cents - discount
  } else {
    if (discount > 0) {
      original_price_cents = service.total_price_cents
    }
  }

  // -------------------------------------

  return (
    <div className={style.serviceContainer}>
      <div className={style.buttonsContainer}>
        {editable && (
          <a
            href="#"
            title={I18n.t("service_ordering.decrease_quantity")}
            onClick={handleDecreaseButtonClicked}
          >
            <span className="fal fa-minus icon" />
          </a>
        )}
        <span className={style.quantity}>{service.quantity}</span>
        {editable && (
          <a
            href="#"
            title={I18n.t("service_ordering.increase_quantity")}
            onClick={handleIncreaseButtonClicked}
          >
            <span className="fal fa-plus icon" />
          </a>
        )}
      </div>

      <div className={style.infoContainer}>
        {service.name}
        <div className={style.additionalParts}>
          {service.additional_parts.map((part, index) => {
            return (
              <span key={part.id}>
                {part.name}
                {service.additional_parts.length - 1 === index ? "" : ","}{" "}
              </span>
            )
          })}
          {service.special_instructions && (
            <div>
              <div className={style.additionalsPartsNotes}>
                {I18n.t("special_instructions")} {service.special_instructions}
              </div>
            </div>
          )}
        </div>
        <ItemPrice
          className={style.price}
          originalPriceCents={original_price_cents}
          priceCents={price_cents}
        />
      </div>
    </div>
  )
}
